import React, {useMemo} from "react";
import {assertArray, assertString, assertObjectValue} from "core/validation";

function ReadOnlyValue({label, type = "text", value, hiddenOnNull = false, icon, listLabel = "label"}) {
    const {printableValue, showLabel} = useMemo(() => {
        let node = null;
        let showLabel = assertObjectValue(value);
        if (type === "text") {
            node = value;
            showLabel = assertString(value);
        }
        if (type === "bool") {
            node = value ? "Enable" : "Disabled";
        }
        if (type === "list") {
            showLabel = assertArray(value);
            node = showLabel ? value.map((v) => v[listLabel]).join(", ") : null;
        }
        if (type === "richText") {
            showLabel = assertArray(value);
            node = <div className={"atsReadOnlyPh"} dangerouslySetInnerHTML={{__html: value}}/>;
        }
        return {
            printableValue: node,
            showLabel
        };
    }, [value, type]);

    if (!showLabel && hiddenOnNull) {
        return null;
    }
    const labelNode = assertObjectValue(label) ? <label>{label}: </label> : null;
    return (
        <div style={{display: "inline-flex"}}>
            {labelNode}
            <span style={{marginLeft: 5}}> {icon}
                {printableValue}
            </span>
        </div>
    );
}


export default function ReadOnlyForm({readOnly, children, ...props}) {
    return readOnly ?  <ReadOnlyValue {...props} /> : children;
}